<template>
  <inquiries-list type="all" :owner="owner"></inquiries-list>
</template>

<script>
import { mapGetters } from "vuex";

import InquiriesList from "@/components/inquiries/List";

export default {
  data: () => ({
    tab: 0
  }),

  props: {
    owner: {
      type: Object,
      required: false
    }
  },

  components: {
    InquiriesList
  }
};
</script>
